import React, { memo, SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {
	className?: string;
}

const MedalStarIcon: React.FC<IProps> = (props) => {
	return (
		<svg
			width="31"
			height="30"
			viewBox="0 0 31 30"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				opacity="0.4"
				d="M24.25 11.25C24.25 13.0625 23.7125 14.725 22.7875 16.1125C21.4375 18.1125 19.3 19.525 16.8125 19.8875C16.3875 19.9625 15.95 20 15.5 20C15.05 20 14.6125 19.9625 14.1875 19.8875C11.7 19.525 9.5625 18.1125 8.2125 16.1125C7.2875 14.725 6.75 13.0625 6.75 11.25C6.75 6.4125 10.6625 2.5 15.5 2.5C20.3375 2.5 24.25 6.4125 24.25 11.25Z"
				fill="white"
			/>
			<path
				d="M27.0626 23.0875L25.0001 23.575C24.5376 23.6875 24.1751 24.0375 24.0751 24.5L23.6376 26.3375C23.4001 27.3375 22.1251 27.6375 21.4626 26.85L15.5001 20L9.5376 26.8625C8.8751 27.65 7.6001 27.35 7.3626 26.35L6.9251 24.5125C6.8126 24.05 6.4501 23.6875 6.0001 23.5875L3.9376 23.1C2.9876 22.875 2.6501 21.6875 3.3376 21L8.2126 16.125C9.5626 18.125 11.7001 19.5375 14.1876 19.9C14.6126 19.975 15.0501 20.0125 15.5001 20.0125C15.9501 20.0125 16.3876 19.975 16.8126 19.9C19.3001 19.5375 21.4376 18.125 22.7876 16.125L27.6626 21C28.3501 21.675 28.0126 22.8625 27.0626 23.0875Z"
				fill="white"
			/>
			<path
				d="M16.225 7.475L16.9625 8.94999C17.0625 9.14999 17.325 9.35 17.5625 9.3875L18.9 9.61249C19.75 9.74999 19.95 10.375 19.3375 10.9875L18.3 12.025C18.125 12.2 18.025 12.5375 18.0875 12.7875L18.3875 14.075C18.625 15.0875 18.0875 15.4875 17.1875 14.95L15.9375 14.2125C15.7125 14.075 15.3375 14.075 15.1125 14.2125L13.8625 14.95C12.9625 15.475 12.425 15.0875 12.6625 14.075L12.9625 12.7875C13.0125 12.55 12.925 12.2 12.75 12.025L11.7125 10.9875C11.1 10.375 11.3 9.76249 12.15 9.61249L13.4875 9.3875C13.7125 9.35 13.975 9.14999 14.075 8.94999L14.8125 7.475C15.175 6.675 15.825 6.675 16.225 7.475Z"
				fill="white"
			/>
		</svg>
	);
};

export default memo(MedalStarIcon);
